import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react'

const CustomerDetails = ({ data }) => {

    const [visible, setVisible] = useState(false)

  return (
    <div className="row">
        <div className="col-md-4 mb-3">
            <label className="fw-semibold text-muted">Profile image</label>
            <img className="mb-0" style={{cursor: 'pointer'}} onClick={() => setVisible(true)} src={`${process.env.REACT_APP_BASE_URL}/${data.userProfilePicture}`} width={200} height={200} onError={(e) => { e.target.src = "/img/placeholder-image.jpg" }}/>
        </div>
        <div className="col-md-4 mb-3">
            <label className="fw-semibold text-muted">Full Name</label>
            <p className="mb-0 text-capitalize">{data?.userName || "-"}</p>
        </div>
        <div className="col-md-4 mb-3">
            <label className="fw-semibold text-muted">Email</label>
            <p className="mb-0">{data?.userEmail || "-"}</p>
        </div>
        <div className="col-md-4 mb-3">
            <label className="fw-semibold text-muted">Mobile Number</label>
            <p className="mb-0">{data?.userMobileNumber || "-"}</p>
        </div>
        <div className="col-md-4 mb-3">
            <label className="fw-semibold text-muted">Signup Date</label>
            <p className="mb-0">
                {data?.createdAt ? new Date(data.createdAt).toLocaleString("en-US", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: true, }) : "-"}
            </p>
        </div>
        <div className="col-md-4 mb-3">
            <label className="fw-semibold text-muted">City</label>
            <p className="mb-0">{data?.city || "-"}</p>
        </div>
        <div className="col-md-4 mb-3">
            <label className="fw-semibold text-muted">State</label>
            <p className="mb-0">{data?.stateName || "-"}</p>
        </div>
        <div className="col-md-4 mb-3">
            <label className="fw-semibold text-muted">Business Category</label>
            <p className="mb-0">{data?.businessCategoryName || "-"}</p>
        </div>
        <div className="col-md-4 mb-3">
            <label className="fw-semibold text-muted">About Me</label>
            <p className="mb-0">{data?.aboutMe || "-"}</p>
        </div>
        <Dialog header={'Profile Picture'} visible={visible} style={{ width: '50vw' }} onHide={() => { if (!visible) return; { setVisible(false) } }} >
            <div className="col-md-12 mb-3">
                <img className="mb-0" src={`${process.env.REACT_APP_BASE_URL}/${data.userProfilePicture}`}/>
            </div>
        </Dialog>
    </div>
  )
}

export default CustomerDetails
